import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import fetchSalonTagsList from 'actions/tags/fetchSalonTagsList.action';
import saveLocalTags from 'actions/tags/saveLocalTags.action';
import { ModalContext } from 'components/core/ModalRoot.component';
import { selectCurrentSalonId } from 'selectors/currentSalon.selectors';
import { selectClientTagsFromSalon, selectEditedClientTags } from 'selectors/simple';
import fromAnyToInteger from 'utils/converters/fromAnyToInteger';
import { fromPropsToClientId } from 'utils/converters/props/bl.util';
import logger from 'utils/logger.util';

import { deleteClient, fetchClient } from 'clientProfile/actions';
import EditDetails from 'clientProfile/components/BasicProfile/EditDetailsContainer';
import ConfirmationDialog from 'clientProfile/components/common/ConfirmationDialog';
import PopupModalContainer from 'common/PopupModal';

const L = logger('EditClientWindow');

class EditClientWindow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      upcomingBookings: 0,
    };
  }

  // noinspection JSCheckFunctionSignatures
  static getDerivedStateFromProps(props, state) {
    const { upcomingBookings } = props;

    if (upcomingBookings !== state.upcomingBookings) return { upcomingBookings };

    return null;
  }

  componentDidMount() {
    const { salonId, getClient, fetchSalonTagsList, saveLocalTags } = this.props;
    const clientId = fromAnyToInteger(fromPropsToClientId(this.props));

    if (!clientId || !salonId) {
      L.warn('componentWillMount()', 'missing id:', { clientId, salonId });
    }

    //  clear the previous loaded labels
    L.unignore('componentWillMount()', 'saveLocalTags:', saveLocalTags([]));
    // fetch new Salon Tags
    L.unignore('componentWillMount()', 'fetchSalonTagsList:', fetchSalonTagsList({ salonId }));
    L.unignore('componentWillMount()', 'getClient:', getClient(salonId, clientId));
  }

  attemptDelete = (showModal) => {
    if (this.state.upcomingBookings > 0) {
      const Modal = ({ onRequestClose }) => (
        <PopupModalContainer
          popupTitle="Client has future booking"
          popupMessage="This client has future bookings, delete those bookings before you delete the client."
          buttonText="Okay"
          buttonCallback={onRequestClose}
        />
      );
      showModal(Modal);
    } else {
      const Modal = ({ onRequestClose }) => (
        <ConfirmationDialog
          title="Delete Client"
          leftButtonText="No"
          onLeft={onRequestClose}
          rightButtonText="Yes"
          onRight={() => {
            this.deleteClient();
            onRequestClose();
          }}
          onCancel={onRequestClose}
        >
          <p>Are you sure you want to delete this client?</p>
        </ConfirmationDialog>
      );
      showModal(Modal);
    }
  };

  deleteClient = () => {
    if (this.props.client && this.props.client.id) {
      this.props.deleteClient(this.props.salonId, { id: this.props.client.id });
      this.props.history.push(`/salon/${this.props.salonId}/day/today`);
    }
  };

  render() {
    const { client, clientTags, isFetchingClient, salonId, salonTags, saveLocalTags } = this.props;
    return (
      <section className="booking-steps">
        <div className="BookingWindow">
          <ModalContext.Consumer>
            {({ showModal }) => (
              <EditDetails
                client={client}
                clientTags={clientTags}
                deleteClient={() => this.attemptDelete(showModal)}
                isFetching={isFetchingClient}
                salonId={salonId}
                salonTags={salonTags}
                saveLocalTags={saveLocalTags}
              />
            )}
          </ModalContext.Consumer>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  client: state.clientProfile.edit_client.data,
  clientTags: selectEditedClientTags(state),
  isFetchingClient: state.clientProfile.edit_client.isFetching,
  salonTags: selectClientTagsFromSalon(state),
  salonId: selectCurrentSalonId(state),
  upcomingBookings: state.clientProfile.edit_client.bookingStatusReport.upcomings,
});

const mapDispatchToProps = (dispatch) => ({
  getClient: (salonId, clientId) => void dispatch(fetchClient(salonId, { id: clientId })),
  ...bindActionCreators({ deleteClient, fetchSalonTagsList, saveLocalTags }, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EditClientWindow));
